import { useEffect, useState } from 'react';
import { getInspectionStandardTypes } from '../../../customerSettings';

export function useGetInspectionStandardTypes() {
    const [inspectionStandardTypes, setInspectionStandardTypes] = useState<string[]>([]);

    useEffect(() => {
        setInspectionStandardTypes(getInspectionStandardTypes());
    }, []);

    return { inspectionStandardTypes };
}
